var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinHelpFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05811 22.0043C2.3884 25.0914 4.87134 27.5744 7.95695 27.9183C10.2488 28.1738 12.602 28.3932 15.0013 28.3932C17.4005 28.3932 19.7537 28.1738 22.0456 27.9183C25.1312 27.5744 27.6141 25.0914 27.9444 22.0043C28.1882 19.7253 28.3941 17.3856 28.3941 15.0003C28.3941 12.615 28.1882 10.2753 27.9444 7.99632C27.6141 4.90922 25.1312 2.42626 22.0456 2.08233C19.7537 1.82686 17.4005 1.60745 15.0013 1.60745C12.602 1.60745 10.2488 1.82686 7.95695 2.08233C4.87134 2.42626 2.3884 4.90921 2.05811 7.99632C1.81429 10.2753 1.6084 12.615 1.6084 15.0003C1.6084 17.3856 1.81429 19.7253 2.05811 22.0043Z",
    fill: "#E8FFD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05811 22.0043C2.3884 25.0914 4.87134 27.5744 7.95695 27.9183C10.2488 28.1738 12.602 28.3932 15.0013 28.3932C17.4005 28.3932 19.7537 28.1738 22.0456 27.9183C25.1312 27.5744 27.6141 25.0914 27.9444 22.0043C28.1882 19.7253 28.3941 17.3856 28.3941 15.0003C28.3941 12.615 28.1882 10.2753 27.9444 7.99632C27.6141 4.90922 25.1312 2.42626 22.0456 2.08233C19.7537 1.82686 17.4005 1.60745 15.0013 1.60745C12.602 1.60745 10.2488 1.82686 7.95695 2.08233C4.87134 2.42626 2.3884 4.90921 2.05811 7.99632C1.81429 10.2753 1.6084 12.615 1.6084 15.0003C1.6084 17.3856 1.81429 19.7253 2.05811 22.0043Z",
    stroke: "#2D471A",
    strokeWidth: 3.21429
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9941 16.4149C14.9941 15.6412 15.6234 15.1666 16.7336 14.4248C17.7633 13.7368 18.3065 12.8442 18.0649 11.6296C17.8232 10.4149 16.8196 9.41126 15.6049 9.16965C13.6982 8.79038 11.8633 10.2963 11.8633 12.2403",
    stroke: "#2D471A",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9934 20.8576C14.8455 20.8576 14.7256 20.7377 14.7256 20.5897C14.7256 20.4418 14.8455 20.3219 14.9934 20.3219",
    stroke: "#2D471A",
    strokeWidth: 3.21429
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9929 20.8577C15.1408 20.8577 15.2607 20.7378 15.2607 20.5898C15.2607 20.4419 15.1408 20.322 14.9929 20.322",
    stroke: "#2D471A",
    strokeWidth: 3.21429
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinHelpFree);
export default __webpack_public_path__ + "static/media/spin-help-free.0be095f35289af196cf465761c662a70.svg";
export { ForwardRef as ReactComponent };